import { Link } from '@klarna/bubble-ui'
import React from 'react'

function extractLinkFromText(legalText: string, query: RegExp) {
  return legalText.split(query)
}

function extractTextType(
  textToken: string,
  colorToken: string,
  legalText: string,
  legalLinkText?: string,
  legalLink?: string
) {
  let textToReturn
  if (legalText.startsWith('{{link')) {
    const splitLegalText = legalText.split(',')
    textToReturn = (
      <Link
        rel='noopener noreferrer'
        target='_blank'
        ariaLabel={`${splitLegalText[1]} (Opens in a new window)`}
        href={splitLegalText[2]}
        textToken={textToken}
        colorToken={colorToken}
        isUnderlined
      >
        {splitLegalText[1]}
      </Link>
    )
    return textToReturn
  }
  if (legalText.includes('{{terms}}')) {
    const arrTexts = extractLinkFromText(legalText, /(\{\{\s?terms\s?[^}]*\}\})/g)
    textToReturn = arrTexts.map(text => (text === '{{terms}}'
      ? legalLinkText && (
        <Link
          rel='noopener noreferrer' target='_blank'
          ariaLabel={'Klarna payment terms (Opens in a new window)'}
          href={legalLink}
          textToken={textToken}
          colorToken={colorToken}
          isUnderlined
        >
          {legalLinkText}
        </Link>
      )
      : text))
    return textToReturn
  }
  return legalText
}

type LegalLinkProps = {
  textToken: string
  colorToken: string
  legalText: string
  legalLinkText?: string
  legalLink?: string
}

const LegalLink: React.FC<LegalLinkProps> = ({
  textToken,
  colorToken,
  legalText = '',
  legalLinkText = '',
  legalLink = '',
}) => (
  <>
    { extractLinkFromText(legalText, /(\{\{\s?link\s?[^}]*)\}\}/g)
      .map(text => extractTextType(textToken, colorToken, text, legalLinkText, legalLink))}
  </>
)

export default LegalLink
